import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GroupFormModal from "components/modals/group_form_modal";
import { createGroup, endEditGroups, updateGroups } from "../../store/actions/properties";

export class PropertiesGroupFormModal extends React.Component {
  static propTypes = {
    createGroup: PropTypes.func.isRequired,
    editingGroups: PropTypes.array,
    endEditGroups: PropTypes.func.isRequired,
    selectedPropertyIds: PropTypes.array.isRequired,
    updateGroups: PropTypes.func.isRequired
  }

  isCreating() {
    const { editingGroups } = this.props;
    return editingGroups && editingGroups.length === 1 && !editingGroups[0].id;
  }

  handleGroupsEdit = (groups) => {
    this.props.updateGroups(groups);
  }

  handleGroupCreate = (groups) => {
    this.props.createGroup(groups[0], this.props.selectedPropertyIds);
  }

  render() {
    return (
      <GroupFormModal
        groups={this.props.editingGroups}
        shown={this.props.editingGroups != null}
        onCancel={this.props.endEditGroups}
        onSubmit={this.isCreating() ? this.handleGroupCreate : this.handleGroupsEdit}
      />
    );
  }
}

const mapStateToProps = state => ({
  editingGroups: state.properties.editingGroups,
  selectedPropertyIds: state.selectList.selectedPropertyIds,
});

const mapDispatchToProps = {
  createGroup,
  endEditGroups,
  updateGroups
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesGroupFormModal);
